<template>
    <v-dialog :value="display" width="350" scrollable>
        <v-card dark :color="color">
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>{{ message }}</v-card-text>
            <v-card-actions>
                <v-btn text @click="close">
                    {{ $t("close_btn") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "AlertDialog",
    data() {
        return {
            message: null,
            color: "info",
            display: false,
            type: null,
            title: null,
        };
    },
    computed: {},
    methods: {
        close() {
            this.display = false;
            this.title = null;
            this.content = null;
        },
        open(params) {
            this.display = true;
            this.type = params.type;
            this.message = params.message;
            this.setTheme();
        },
        setTheme() {
            switch (this.type) {
                case "success":
                    this.color = "success";
                    this.title = this.$t("success_title");
                    break;
                case "error":
                    this.color = "error";
                    this.title = this.$t("error_title");
                    break;
                case "info":
                    this.color = "info";
                    this.title = this.$t("info_title");
                    break;
                default:
                    this.title = this.$t("alert_title");
                    break;
            }
        },
    },
    mounted() {},
};
</script>
